export default __webpack_public_path__ + "static/media/Gold_Nov20_Rank.ca20bbd0.png";